import { combineReducers } from "redux";
import * as auth from "../app/modules/Auth/redux/authReducer";
import * as environnment from "../app/modules/GetEnvironment/getEnvironmentReducer";
import * as profile from "../app/modules/profile_settings/redux";
import snackBarReducer from "../app/modules/snackBar/snackbarReducer";
import * as candidatesMaster from "../app/modules/candidates_master/redux";
import * as dashboard from "../app/modules/dashboards/redux";
import * as user from "../app/modules/users/redux";

export const rootReducer = combineReducers({
  snackBar: snackBarReducer,
  environnment: environnment.reducer,
  auth: auth.reducer,
  profile: profile.reducer,
  candidates_master: candidatesMaster.reducer,
  dashboard: dashboard.reducer,
  user: user.reducer,
});
